import React from 'react';
import { IconCheck, IconCopy, IconStack2, IconX } from '@tabler/icons-react';
import { BoardStage } from '../../../entities/board';
import { Lead } from '../../../entities/lead/model/types';
import type { Tag } from '../../../entities/tag';
import { getThemeFromStage } from '../../../shared/config/stages';
import { formatDate } from '../../../shared/lib/utils';
import { ChipSelect } from '../../../shared/ui/ChipSelect';
import { Select } from '../../../shared/ui/Select';

interface Props {
  lead: Lead;
  stages: BoardStage[];
  boardId: string;
  copiedLeadId: boolean;
  leadSource?: string;
  allTags: Tag[];
  tagValues: string[];
  onTagsChange: (v: string[]) => void;
  onBoardIdChange: (value: string) => void;
  onCopyLeadId: () => void;
  onClose: () => void;
}

const CardModalHeader: React.FC<Props> = ({
  lead,
  stages,
  boardId,
  copiedLeadId,
  leadSource,
  allTags,
  tagValues,
  onTagsChange,
  onBoardIdChange,
  onCopyLeadId,
  onClose,
}) => {
  const selectedStage = stages.find(item => item.id === boardId);
  const selectedStageTheme = selectedStage ? getThemeFromStage(selectedStage) : getThemeFromStage({});

  return (
    <div className="cm-top">
      <div>
        <div className="cm-ti">{lead.title || 'Без названия'}</div>
        <div className="cm-sub">
          <button type="button" className={`cm-id-copy${copiedLeadId ? ' copied' : ''}`} onClick={onCopyLeadId} title="Скопировать ID">
            {copiedLeadId
              ? <IconCheck size={11} stroke={2.5} />
              : <IconCopy size={11} stroke={2} />}
            #{lead.id.slice(-4)}
          </button>
          <span className="cm-sub-sep">·</span>
          создан {formatDate(lead.created)}
          <span className="cm-sub-sep">·</span>
          обновлён {formatDate(lead.updated)}
          {leadSource && <><span className="cm-sub-sep">·</span>{leadSource}</>}
        </div>
      </div>
      <div className="cm-sp" />
      {allTags.length > 0 && (
        <ChipSelect
          options={allTags.map(t => ({ value: t.id, label: t.name, colors: t.colors }))}
          value={tagValues}
          onChange={onTagsChange}
          addLabel="Добавить тег"
        />
      )}
      <div className="cm-stage-row">
        <div className="cm-stage-lbl">Этап:</div>
        <Select
          options={stages.map(stage => ({ value: stage.id, label: stage.name }))}
          value={boardId}
          onChange={onBoardIdChange}
          icon={<IconStack2 size={16} stroke={1.9} />}
          className="cm-stage-sel-wrap"
          triggerStyle={{
            backgroundColor: selectedStageTheme.background,
            borderColor: selectedStageTheme.border,
            color: selectedStageTheme.text,
          }}
        />
      </div>
      <button className="cm-x" onClick={onClose} type="button" aria-label="Закрыть">
        <IconX size={18} stroke={2.2} />
      </button>
    </div>
  );
};

export { CardModalHeader };
